import { msToClock } from "@lib/utils";
import { useCallback, useEffect, useState } from "react";
import { Played, Total, Wrapper } from "./Clock.style";

interface Props {
	timestamp: () => number;
	total: number;
}

const Clock: React.FC<Props> = ({ timestamp, total }) => {
	const [time, setTime] = useState(0);

	const updateClock = useCallback(() => {
		setTime(timestamp());
	}, [timestamp]);

	useEffect(() => {
		const it = setInterval(updateClock, 250);

		return () => clearInterval(it);
	}, [updateClock]);

	return (
		<Wrapper>
			<Played data-testid="player-clock-played_time">{msToClock(time, true)}</Played>
			<Total>{msToClock(total, true)}</Total>
		</Wrapper>
	);
};

export default Clock;
